import { render } from "./InspectionCall.vue?vue&type=template&id=3ea32d92"
import script from "./InspectionCall.vue?vue&type=script&lang=js"
export * from "./InspectionCall.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__